module.exports = __webpack_public_path__ + "img/new-rank-bg-mobile.a083718e.png";